import React, { FC } from 'react'
import styled from 'styled-components'
import { Box, Container, Link, Text, Stack, SimpleGrid } from '@chakra-ui/react'
import { CarplannerButton } from 'src/uikit'

const Icon = styled.span`
  & svg {
    display: inline-block;
    margin: auto;
  }
`

const InfoBox2: FC<BoxGlobal.InfoBox2> = ({ title, boldTitle, description, boldDescription, action, actionTitle, href, icon }) => {

  const startTitleIndex = title.indexOf(boldTitle);
  let beforeBoldTitle:string;
  let afterBoldTitle:string;

  if (startTitleIndex !== -1) {
    beforeBoldTitle = title.substring(0, startTitleIndex);
    afterBoldTitle = title.substring(startTitleIndex + boldTitle.length);
  }

  const startDescriptionIndex = description.indexOf(boldDescription);
  let beforeBoldDescription:string;
  let afterBoldDescription:string;

  if (startDescriptionIndex !== -1) {
    beforeBoldDescription = description.substring(0, startDescriptionIndex);
    afterBoldDescription = description.substring(startDescriptionIndex + boldDescription.length);
  }

  return (
    <Box bg="primaryGreen.50">
      <Container as={Stack} maxW="100%" py={10} textAlign="center" p="l">
        <SimpleGrid
          templateColumns={{ base: '1fr', sm: '1fr', md: '1fr 1.1fr 1.1fr' }}
          marginY="xxl"
          spacing={{ base: 'l', sm: 'l', md: 'xl' }}
        >
          <Box textAlign={{ base: 'center', sm: 'center', md: 'right' }}>
            <Icon>{icon}</Icon>
          </Box>
          <Box>
            <Text
              color="baseDark"
              fontFamily="Montserrat-Regular"
              fontSize="1.375rem"
              letterSpacing="0.6px"
              lineHeight="28.6px"
              whiteSpace="nowrap"
              marginBottom="xs"
              textAlign={{base: 'center', sm: 'center', md: 'left'}}
            >
              {beforeBoldTitle}<strong>{boldTitle}</strong>{afterBoldTitle}
            </Text>
            <Text
              color="baseDark"
              fontFamily="Montserrat-Regular"
              fontSize="1rem"
              letterSpacing="0.2px"
              lineHeight="20.8px"
              whiteSpace="pre-wrap"
              textAlign={{ base: 'center', sm: 'center', md: 'left' }}
            >
              {beforeBoldDescription}<strong>{boldDescription}</strong>{afterBoldDescription}
            </Text>
          </Box>
          <Box my="auto" textAlign={{ base: 'center', sm: 'center', md: 'left' }}>
            <Link href={href}>
              <CarplannerButton
                title={actionTitle}
                action={action}
                width="12.438rem"
                textTransform="uppercase"
                display="inline"
              />
            </Link>
          </Box>
        </SimpleGrid>
      </Container>
    </Box>
  )
}

export default InfoBox2
